import * as i0 from '@angular/core';
import { Input, Inject, Component, NgModule, Injectable, EventEmitter, PLATFORM_ID, Optional } from '@angular/core';
import { CommonModule, DOCUMENT, isPlatformServer, isPlatformBrowser } from '@angular/common';
import * as i1$1 from '@citi-gcg-173875/citi-utils';
import { WINDOW, IS_SSRENDERED_APP, WINDOW_PROVIDER } from '@citi-gcg-173875/citi-utils';
import * as i1 from '@angular/common/http';
import { catchError, throwError, Observable, of, BehaviorSubject, map as map$1, take } from 'rxjs';
import * as i2 from '@citi-gcg-173875/citi-http';
import * as rs from 'jsrsasign';
import * as JsEncryptModule from 'jsencrypt';
import { encrypt, decrypt } from 'crypto-js/aes';
import * as CryptoJS_EncHex from 'crypto-js/enc-hex';
import { Cookie } from 'ng2-cookies';
import Utf8 from 'crypto-js/enc-utf8';
import { catchError as catchError$1, map, flatMap, filter, switchMap } from 'rxjs/operators';
import * as i1$2 from '@angular/router';
import { GuardsCheckEnd } from '@angular/router';

class AmwComponent {
    constructor(_window, _httpClient, _storageService) {
        this._window = _window;
        this._httpClient = _httpClient;
        this._storageService = _storageService;
        this.JFPSESSIONID = 'sessionJFP_ID';
        this.USERID = 'CCSID';
        this.AMW_REST_END_POINT = '/US/REST/amwresource/amwajax.jws';
        this.enableAmwPolling = true;
    }
    ngOnInit() {
        // if (!this._window) return;
        // Read the session id from sessionstorage and set it window object.
        // Read the ccsId from cookie and set it window Object for post Login
        // let sessionId = this._window.sessionStorage.getItem(this.JFPSESSIONID),
        //   userId = this._storageService.get(this.USERID, StorageService.COOKIE);
        // if (sessionId) {
        //   this._window.userSessionId = 'CBOL:' + sessionId;
        // }
        // if (userId) {
        //   this._window.ccsId = userId;
        // }
    }
    ngAfterViewInit() {
        // if (!this._window) return;
        // if (typeof this._window.getData3 === 'function') {
        //   this.postDataToTrusteer(this._window, this.amwTag);
        // } else {
        //   let intervalId = setInterval(() => {
        //     if (typeof this._window.getData3 === 'function') {
        //       this.postDataToTrusteer(this._window, this.amwTag);
        //       clearInterval(intervalId);
        //     }
        //   }, 500);
        // }
        // if (this.enableAmwPolling) {
        //   this.postAmwResponseToCBOL();
        // }
    }
    postDataToTrusteer(window, tag) {
        // tslint:disable-next-line:only-arrow-functions
        // (function(window, tag) {
        //   window['getData3'](tag);
        // })(window, this.amwTag);
    }
    postAmwResponseToCBOL() {
        // if (!this._window) return;
        // if (this._window.encrString != '') {
        //   this.sendAMWResponseToCBOL();
        // } else {
        //   let intervalId = setInterval(() => {
        //     if (this._window.encrString != '') {
        //       this.sendAMWResponseToCBOL();
        //       clearInterval(intervalId);
        //     }
        //   }, 500);
        // }
    }
    sendAMWResponseToCBOL() {
        // if (!this._window) return;
        // let hostName = this._window.location.hostname,
        //   protocol = this._window.location.protocol,
        //   headers = new HttpHeaders({ 'Content-Type': 'application/json' }),
        //   trustRes1 = encodeURIComponent(this._window.encrString),
        //   initVecWithChar1 = encodeURIComponent(this._window.initVecString),
        //   data = 'encrStr=' + trustRes1 + '&initVec=' + initVecWithChar1,
        //   url = protocol + '//' + hostName + this.AMW_REST_END_POINT;
        // this._httpClient
        //   .post(url, JSON.stringify(data), { headers })
        //   .subscribe(error => console.log(error));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AmwComponent, deps: [{ token: WINDOW }, { token: i1.HttpClient }, { token: i1$1.StorageService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.14", type: AmwComponent, isStandalone: false, selector: "cbol-amw", inputs: { amwTag: "amwTag", enableAmwPolling: "enableAmwPolling" }, ngImport: i0, template: ``, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AmwComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cbol-amw',
                    standalone: false,
                    template: ``
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i1.HttpClient }, { type: i1$1.StorageService }], propDecorators: { amwTag: [{
                type: Input
            }], enableAmwPolling: [{
                type: Input
            }] } });

class AmwModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AmwModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: AmwModule, declarations: [AmwComponent], imports: [CommonModule], exports: [AmwComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AmwModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AmwModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [AmwComponent],
                    exports: [AmwComponent]
                }]
        }] });

class E2eService {
    constructor(_http, _e2eHelper, _cookieService, _appConfigService, _httpClient, rendererFactory, document) {
        this._http = _http;
        this._e2eHelper = _e2eHelper;
        this._cookieService = _cookieService;
        this._appConfigService = _appConfigService;
        this._httpClient = _httpClient;
        this.rendererFactory = rendererFactory;
        this.document = document;
        this.newSessionDeleteLogic = false;
        this.e2eKeyUrl = '/security/e2e/key';
        this.precacheRan = false;
        this.encFieldTypeValueMap = {
            pin: 'a',
            password: 'b',
            formdata: 'c'
        };
        this.newSessionDeleteLogic = !!this._appConfigService.getSessionDeleteFlagConfig();
        this._renderer = rendererFactory.createRenderer(null, null);
        this.jsencrypt = new JsEncryptModule.JSEncrypt();
    }
    //method added for fallback old e2e
    getPbKey() {
        return this.publicKey;
    }
    conditionCheck() {
        /* added below code if there is no biztoken is available on the registration flow */
        let biztoken = this._cookieService.getCookie("bizToken");
        if (this.newSessionDeleteLogic && (!this._e2eHelper.getEventID() || !this.publicKey)) {
            return true;
        }
        else if (!this._e2eHelper.getEventID() || !this.publicKey || (this._e2eHelper.gete2eBizToken() && this._e2eHelper.gete2eBizToken() != biztoken) && !biztoken) {
            return true;
        }
        return false;
    }
    async encryptData(dataToEnc, encDataType, isCRS, customCall, customURL, customHeaders) {
        isCRS ? this.e2eKeyUrl = '/crs/security/e2e/key' : this.e2eKeyUrl = '/security/e2e/key';
        // customURL flag is enabled for journey teams to pass APIGEE key url based on different containers. Pass Full URL
        if (customURL) {
            this.e2eKeyUrl = customURL;
        }
        // Restrict customHeaders to specific tenant and channel IDs
        if (this._appConfigService.getConfig().httpService.defaultHeaders.channelId !== "RBBLENDING") {
            customHeaders = null;
        }
        // Create options object based on whether custom headers exist
        const options = customHeaders ? { headers: customHeaders } : undefined;
        // customCall flag is enabled for journey teams to invoke key call independent of conditional check
        if (this.conditionCheck() || customCall) {
            return await this.getE2eExchangeKey(dataToEnc, encDataType, options);
        }
        else {
            if (this._e2eHelper.checkEventIDTimeisValid()) {
                if (dataToEnc)
                    return this.encryption(dataToEnc, encDataType);
                return "";
            }
            else {
                const e2eKeyRequest = this.PostRequestValues();
                return await this._http.post(this.e2eKeyUrl, e2eKeyRequest, options).toPromise().then(() => {
                    if (this.isSRValid())
                        return this.encryption(dataToEnc, encDataType);
                    return "";
                }).catch((res) => {
                    console.error('E2E - POST KEY Call Failed..');
                    this.errorLogging(res);
                    return "";
                });
            }
        }
    }
    async getE2eExchangeKey(dataToEnc, encDataType, options) {
        let rsaE2eKey = await this._http.get(this.e2eKeyUrl, options, null, null, true).toPromise().catch((res) => {
            console.error('E2E - GET KEY Call Failed.');
            this.errorLogging(res);
            return "";
        });
        // manually added cookie for precache check
        let precacheCookie = this._cookieService.getCookie("precacheA");
        //check for x-debug-drain header
        let callPrecache = rsaE2eKey?.headers?.headers.get('x-debug-drain');
        let checkPrecacheValue = callPrecache?.some(item => item.toLowerCase().includes('good'));
        //pre-caching dashboard implementation
        if (checkPrecacheValue && precacheCookie === 'true') {
            this.precacheDashboard();
        }
        if (rsaE2eKey) {
            this.publicKey = rs.KEYUTIL.getKey({
                n: rsaE2eKey?.body?.modulus,
                e: rsaE2eKey?.body?.exponent
            });
            const e2eKeyRequest = this.PostRequestValues();
            return await this._http.post(this.e2eKeyUrl, e2eKeyRequest, options).toPromise().then(() => {
                if (this.isSRValid()) {
                    if (dataToEnc)
                        return this.encryption(dataToEnc, encDataType);
                    return "";
                }
                else {
                    console.error("E2E Invalid " + this.initErrorMsg);
                    return "";
                }
            }).catch((res) => {
                console.error('E2E - GET POST Call Failed.');
                this.errorLogging(res);
                return "";
            });
        }
        else {
            console.error('E2E - GET KEY Call Failed.');
            return "";
        }
    }
    precacheDashboard() {
        if (this.precacheRan) {
            return;
        }
        const originURL = this._appConfigService.getnewCitiHostName();
        const dashboardProxyURL = originURL + '/US/ag/dashboard';
        this._httpClient.get(dashboardProxyURL, { responseType: 'text' })
            .pipe(catchError(error => {
            console.error('Precache: Failed to prefetch dashboard main.js:', error);
            return throwError(() => new Error(error));
        }))
            .subscribe(htmlContent => {
            try {
                const regex = /main\.[a-zA-Z0-9]+\.js/;
                const match = regex.exec(htmlContent);
                console.log('Precache: Match found:', match);
                if (match) {
                    const latestMain = match[0];
                    console.log(`Found main script: ${latestMain}`);
                    const link = this._renderer.createElement('link');
                    this._renderer.setAttribute(link, 'rel', 'prefetch');
                    this._renderer.setAttribute(link, 'href', `${originURL}/US/ag/${latestMain}`);
                    this._renderer.setAttribute(link, 'as', 'script');
                    const head = this.document.head;
                    this._renderer.appendChild(head, link);
                }
                else {
                    console.warn('Precache: Main script not found in the HTML content');
                }
            }
            catch (error) {
                console.error('Precache: Error occurred while processing regex:', error);
            }
        });
        this.precacheRan = true;
    }
    PostRequestValues() {
        const encAesKey = this.getEncryptedKey();
        const ekCD = this._e2eHelper.generateCheckDigit(this._e2eHelper.geteKey());
        const hkCD = this._e2eHelper.generateCheckDigit(this._e2eHelper.gethKey());
        // The cstype field was empty string. Hence this can be ignored
        const e2eKeyRequest = {
            encryptedPayload: encAesKey,
            encKeyCheckDigit: ekCD,
            hmacKeyCheckDigit: hkCD,
            algorithm: 'AES'
        };
        return e2eKeyRequest;
    }
    // This method would decryot the SR from response header so that decrypted SR can be used to encrypt data
    // This method returns true if SR is valid
    isSRValid() {
        try {
            //to use the existing eventid not to update the new eventid on the post call
            // this.eventID = this._storageService.get(this.sRKey);
            let eventID = this._e2eHelper.getEventID();
            let cipherDotMac, cipherBase64, cipherHMacBase64, cipher, remoteHmac, localHmac;
            if (eventID) {
                cipherDotMac = eventID.split('.');
                cipherBase64 = cipherDotMac[0];
                cipherHMacBase64 = cipherDotMac[1];
                cipher = rs.b64nltohex(cipherBase64);
                remoteHmac = rs.b64nltohex(cipherHMacBase64);
                localHmac = this._e2eHelper.getHMAC256Hash(cipher, this._e2eHelper.gethKey());
                if (remoteHmac !== localHmac) {
                    this.initErrorMsg = 'client SR HMAC not matching with Server SR HMAC';
                    return false;
                }
                else {
                    this.sRToEnc = this._e2eHelper.decryptDataWithAesKey(cipher);
                    if (this.sRToEnc === undefined || this.sRToEnc === '') {
                        this.initErrorMsg = 'error occured while decrypting SR';
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
            else {
                return false;
            }
        }
        catch (e) {
            this.initErrorMsg = 'error occured while decrypting SR';
            return false;
        }
    }
    // This method returns RSA Encrypted EncryptionKey + InitVector + HashKey
    getEncryptedKey() {
        if (!this._e2eHelper.getiv()) {
            this._e2eHelper.randomValues();
        }
        const keyStr = this._e2eHelper.geteKey() + this._e2eHelper.getiv() + this._e2eHelper.gethKey();
        let encKeyStr = '';
        try {
            const publicKeyPEM = rs.KEYUTIL.getPEM(this.publicKey);
            this.jsencrypt.setPublicKey(publicKeyPEM);
            encKeyStr = this.jsencrypt.encrypt(keyStr);
            return rs.b64nltohex(encKeyStr);
        }
        catch (e) {
            throw new Error('Error occured while encrypting the AES Key');
        }
    }
    encryption(dataEncrypt, dataTypeEnc) {
        try {
            //clear the previous used eventid for splunk logging 
            this._e2eHelper.setLogPreEventid("");
            const sensitiveMsg = this._e2eHelper.getCR() +
                this.getDecryptedSR() +
                this.encFieldTypeValueMap[dataTypeEnc] +
                dataEncrypt, encSensitiveMsgHex = this.aesEncDataHex(sensitiveMsg), cipherBase64 = this.getBase64FromHex(encSensitiveMsgHex), cipherHmac = this._e2eHelper.getHMAC256Hash(encSensitiveMsgHex, this._e2eHelper.gethKey()), cipherHmacBase64 = this.getBase64FromHex(cipherHmac), encData = cipherBase64 + '.' + cipherHmacBase64;
            const offset = -5.0, currDate = new Date(), utc = currDate.getTime() + (currDate.getTimezoneOffset() * 60000), currentDateTime = new Date(utc + 3600000 * offset);
            this._e2eHelper.setOldTimeStamp(currentDateTime);
            console.log("ss_first_encryp_currentDateTime__", currentDateTime);
            //set the new eventid that is used during the encryption and write it down on the splunk log
            this._e2eHelper.setLogPreEventid(this._e2eHelper.getEventID());
            return encData;
        }
        catch (e) {
            throw new Error(e);
        }
    }
    decryptData(dataToDec) {
        const cipherDotMac = dataToDec.split('.'), cipherBase64 = cipherDotMac[0], cipherHMacBase64 = cipherDotMac[1], cipher = rs.b64nltohex(cipherBase64), remoteHmac = rs.b64nltohex(cipherHMacBase64), localHmac = this._e2eHelper.getHMAC256Hash(cipher, this._e2eHelper.gethKey());
        if (remoteHmac !== localHmac) {
            throw new Error('Decryption failed server hash and client hash not matching');
        }
        else {
            const decData = this._e2eHelper.decryptDataWithAesKey(cipher), resCR = decData.substring(0, 32), resSR = decData.substring(32, 64), resData = decData.substring(64, decData.length);
            if (resSR === this.sRToEnc && resCR === this._e2eHelper.getCR()) {
                // Client Random and Server Random matches
                // Hence the data from response is the actual data
                return resData;
            }
            else {
                throw new Error('Decryption failed - client random and server random did not match');
            }
        }
    }
    aesEncDataHex(dataToEnc) {
        // The ciphertext you get back after encryption isn't a string yet. It's a CipherParams object.
        const encData = encrypt(dataToEnc, CryptoJS_EncHex.parse(this._e2eHelper.geteKey()), {
            iv: CryptoJS_EncHex.parse(this._e2eHelper.getiv())
        });
        return encData.ciphertext.toString(CryptoJS_EncHex);
    }
    getBase64FromHex(hexData) {
        return rs.hextob64(hexData);
    }
    getDecryptedSR() {
        if (this.isSRValid()) {
            return this.sRToEnc;
        }
        else {
            throw new Error('Invalid SR');
        }
    }
    errorLogging(res) {
        //Error Log on Splunk for event id
        let uuid = res?.headers?.get('uuid');
        let user = sessionStorage.getItem('sessionPostBrandingStorage');
        if (user) {
            user = JSON.parse(user).loginName;
        }
        let reqBody = {
            "userId": user ? user : '',
            "errorCode": res?.headers?.status,
            "uuid": uuid,
            "appVersion": "CBOL",
            "moreInfo": "Event Id used during encryption is " + this._e2eHelper.getLogPreEventid()
        };
        this._http.post("/prelogin/digital/reporting/userInterface/errorLogging", reqBody).toPromise().catch(() => {
            console.error('Error Logging Api is failing');
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eService, deps: [{ token: i2.HttpService }, { token: i2.E2eHelper }, { token: i1$1.CookieService }, { token: i1$1.AppConfigService }, { token: i1.HttpClient }, { token: i0.RendererFactory2 }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i2.HttpService }, { type: i2.E2eHelper }, { type: i1$1.CookieService }, { type: i1$1.AppConfigService }, { type: i1.HttpClient }, { type: i0.RendererFactory2 }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class E2eServiceFallback {
    constructor(_appConfigService, _http, _e2eHelper, _cookieService, _e2eService) {
        this._appConfigService = _appConfigService;
        this._http = _http;
        this._e2eHelper = _e2eHelper;
        this._cookieService = _cookieService;
        this._e2eService = _e2eService;
        this.newSessionDeleteLogic = false;
        this.e2eKeyUrl = '/security/e2e/key';
        this.encFieldTypeValueMap = {
            pin: 'a',
            password: 'b',
            formdata: 'c'
        };
        this.newSessionDeleteLogic = !!this._appConfigService.getSessionDeleteFlagConfig();
        this.jsencrypt = new JsEncryptModule.JSEncrypt();
    }
    // TO-DO: DELETE LATER
    testCrypto(toEncrypt) {
        let blanko = {};
        let encData = encrypt(toEncrypt, 'passphrase');
        let decData = decrypt(encData, 'passphrase');
        let decrypted = decData != null ? decData.toString(Utf8) : null;
        blanko = {
            encrypted: encData,
            decrypted: decrypted
        };
        return blanko;
    }
    performKeyExchange() {
        /* added below code if there is no biztoken is available on the registration flow */
        let biztoken = this._cookieService.getCookie("bizToken");
        if (!Cookie.get('isLoggedIn')) {
            this.qrCodeLogin = this._cookieService.getCookie("qrCodeLogin");
        }
        if (!this.publicKey) {
            this.publicKey = this._e2eService.getPbKey();
        }
        if ((this.newSessionDeleteLogic && (!this._e2eHelper.getEventID() || !this.publicKey)) || this.qrCodeLogin) {
            return this.getExchangeEventKey();
        }
        else if (!this._e2eHelper.getEventID() || !this.publicKey || (this._e2eHelper.gete2eBizToken() && this._e2eHelper.gete2eBizToken() != biztoken) && !biztoken) {
            return this.getExchangeEventKey();
        }
        else {
            if (this._e2eHelper.checkEventIDTimeisValid()) {
                let val = Observable.create(observer => {
                    observer.next(true);
                    observer.complete();
                });
                return of(val);
            }
            else {
                return this.postExchangeEventKey();
            }
        }
    }
    getExchangeEventKey() {
        return this._http.get(this.e2eKeyUrl).pipe(catchError$1((error) => {
            this._e2eService.errorLogging(error);
            return of(false);
        }), map(rsaE2eResponse => {
            if (rsaE2eResponse) {
                this.rsaE2eKey = rsaE2eResponse;
                try {
                    this.publicKey = rs.KEYUTIL.getKey({
                        n: this.rsaE2eKey.modulus,
                        e: this.rsaE2eKey.exponent
                    });
                    return this.publicKey;
                }
                catch (e) {
                    return of(false);
                }
            }
        }), flatMap(() => {
            const encAesKey = this.getEncryptedKey();
            const ekCD = this._e2eHelper.generateCheckDigit(this._e2eHelper.geteKey());
            const hkCD = this._e2eHelper.generateCheckDigit(this._e2eHelper.gethKey());
            // The cstype field was empty string. Hence this can be ignored
            const e2eKeyRequest = {
                encryptedPayload: encAesKey,
                encKeyCheckDigit: ekCD,
                hmacKeyCheckDigit: hkCD,
                algorithm: 'AES'
            };
            return this._http.post(this.e2eKeyUrl, e2eKeyRequest).pipe(catchError$1((error) => {
                this._e2eService.errorLogging(error);
                return of(false);
            }), map(data => {
                if (this.isSRValid()) {
                    return of(true);
                }
                else {
                    return of(false);
                }
            }));
        }));
    }
    // This method would decryot the SR from response header so that decrypted SR can be used to encrypt data
    // This method returns true if SR is valid
    isSRValid() {
        try {
            //to use the existing eventid not to update the new eventid on the post call
            // this.eventID = this._storageService.get(this.sRKey);
            let eventID = this._e2eHelper.getEventID();
            let cipherDotMac, cipherBase64, cipherHMacBase64, cipher, remoteHmac, localHmac;
            if (eventID) {
                cipherDotMac = eventID.split('.');
                cipherBase64 = cipherDotMac[0];
                cipherHMacBase64 = cipherDotMac[1];
                cipher = rs.b64nltohex(cipherBase64);
                remoteHmac = rs.b64nltohex(cipherHMacBase64);
                localHmac = this._e2eHelper.getHMAC256Hash(cipher, this._e2eHelper.gethKey());
                if (remoteHmac !== localHmac) {
                    this.initErrorMsg = 'client SR HMAC not matching with Server SR HMAC';
                    return false;
                }
                else {
                    this.sRToEnc = this._e2eHelper.decryptDataWithAesKey(cipher);
                    if (this.sRToEnc === undefined || this.sRToEnc === '') {
                        this.initErrorMsg = 'error occured while decrypting SR';
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            }
            else {
                return false;
            }
        }
        catch (e) {
            this.initErrorMsg = 'error occured while decrypting SR';
            return false;
        }
    }
    postExchangeEventKey() {
        const encAesKey = this.getEncryptedKey();
        const ekCD = this._e2eHelper.generateCheckDigit(this._e2eHelper.geteKey());
        const hkCD = this._e2eHelper.generateCheckDigit(this._e2eHelper.gethKey());
        // The cstype field was empty string. Hence this can be ignored
        const e2eKeyRequest = {
            encryptedPayload: encAesKey,
            encKeyCheckDigit: ekCD,
            hmacKeyCheckDigit: hkCD,
            algorithm: 'AES'
        };
        return this._http.post(this.e2eKeyUrl, e2eKeyRequest).pipe(catchError$1((error) => {
            this._e2eService.errorLogging(error);
            return of(false);
        }), map(data => {
            if (this.isSRValid()) {
                return of(true);
            }
            else {
                return of(false);
            }
        }));
    }
    // This method returns RSA Encrypted EncryptionKey + InitVector + HashKey
    getEncryptedKey() {
        if (!this._e2eHelper.getiv()) {
            this._e2eHelper.randomValues();
        }
        const keyStr = this._e2eHelper.geteKey() + this._e2eHelper.getiv() + this._e2eHelper.gethKey();
        let encKeyStr = '';
        try {
            const publicKeyPEM = rs.KEYUTIL.getPEM(this.publicKey);
            this.jsencrypt.setPublicKey(publicKeyPEM);
            encKeyStr = this.jsencrypt.encrypt(keyStr);
            return rs.b64nltohex(encKeyStr);
        }
        catch (e) {
            throw new Error('Error occured while encrypting the AES Key');
        }
    }
    encryptData(dataToEnc, encDataType) {
        /* this.performKeyExchange().subscribe(
           (response: any): any => {
             let e2eval: string;
             response.subscribe(val => (e2eval = `${val}`));
             if (e2eval === 'true') {
               console.log("coming iside e2e true");
             }
             else {
               console.log("coming iside e2e failure");
             }
           }
         ); */
        try {
            //clear the previous used eventid for splunk logging
            this._e2eHelper.setLogPreEventid("");
            const sensitiveMsg = this._e2eHelper.getCR() +
                this.getDecryptedSR() +
                this.encFieldTypeValueMap[encDataType] +
                dataToEnc, encSensitiveMsgHex = this.aesEncDataHex(sensitiveMsg), cipherBase64 = this.getBase64FromHex(encSensitiveMsgHex), cipherHmac = this._e2eHelper.getHMAC256Hash(encSensitiveMsgHex, this._e2eHelper.gethKey()), cipherHmacBase64 = this.getBase64FromHex(cipherHmac), encData = cipherBase64 + '.' + cipherHmacBase64;
            const offset = -5.0, currDate = new Date(), utc = currDate.getTime() + (currDate.getTimezoneOffset() * 60000), currentDateTime = new Date(utc + 3600000 * offset);
            this._e2eHelper.setOldTimeStamp(currentDateTime);
            console.log("ss_first_encryp_currentDateTime__", currentDateTime);
            //set the new eventid that is used during the encryption and write it down on the splunk log
            this._e2eHelper.setLogPreEventid(this._e2eHelper.getEventID());
            return encData;
        }
        catch (e) {
            throw new Error(e);
        }
    }
    decryptData(dataToDec) {
        const cipherDotMac = dataToDec.split('.'), cipherBase64 = cipherDotMac[0], cipherHMacBase64 = cipherDotMac[1], cipher = rs.b64nltohex(cipherBase64), remoteHmac = rs.b64nltohex(cipherHMacBase64), localHmac = this._e2eHelper.getHMAC256Hash(cipher, this._e2eHelper.gethKey());
        if (remoteHmac !== localHmac) {
            throw new Error('Decryption failed server hash and client hash not matching');
        }
        else {
            const decData = this._e2eHelper.decryptDataWithAesKey(cipher), resCR = decData.substring(0, 32), resSR = decData.substring(32, 64), resData = decData.substring(64, decData.length);
            if (resSR === this.sRToEnc && resCR === this._e2eHelper.getCR()) {
                // Client Random and Server Random matches
                // Hence the data from response is the actual data
                return resData;
            }
            else {
                throw new Error('Decryption failed - client random and server random did not match');
            }
        }
    }
    aesEncDataHex(dataToEnc) {
        // The ciphertext you get back after encryption isn't a string yet. It's a CipherParams object.
        const encData = encrypt(dataToEnc, CryptoJS_EncHex.parse(this._e2eHelper.geteKey()), {
            iv: CryptoJS_EncHex.parse(this._e2eHelper.getiv())
        });
        return encData.ciphertext.toString(CryptoJS_EncHex);
    }
    getBase64FromHex(hexData) {
        return rs.hextob64(hexData);
    }
    getDecryptedSR() {
        if (this.isSRValid()) {
            return this.sRToEnc;
        }
        else {
            throw new Error('Invalid SR');
        }
    }
    initE2e() {
        if (this.e2eKeyUrl != '/security/e2e/key') {
            this.e2eKeyUrl = '/security/e2e/key';
        }
        return this.performKeyExchange();
    }
    crsinitE2e() {
        this.e2eKeyUrl = '/crs/security/e2e/key';
        return this.performKeyExchange();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eServiceFallback, deps: [{ token: i1$1.AppConfigService }, { token: i2.HttpService }, { token: i2.E2eHelper }, { token: i1$1.CookieService }, { token: E2eService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eServiceFallback, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: E2eServiceFallback, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.AppConfigService }, { type: i2.HttpService }, { type: i2.E2eHelper }, { type: i1$1.CookieService }, { type: E2eService }] });

class AuthorizationService {
    static { this.NGA = 'nga'; }
    static { this.legacy = 'legacy'; }
    constructor(storageService, appConfig, router, httpService, sessionService, cookieService, _platformId, _isSSRApp) {
        this.storageService = storageService;
        this.appConfig = appConfig;
        this.router = router;
        this.httpService = httpService;
        this.sessionService = sessionService;
        this.cookieService = cookieService;
        this._platformId = _platformId;
        this._isSSRApp = _isSSRApp;
        this.sessionIdentifiers = this.appConfig.getSessionIdentifiers();
        this._sessionType = null;
        this.sessionTypeEmitter = new EventEmitter();
        this.newSessionDeleteLogic = false;
        this.getPartnerId = new BehaviorSubject('');
        this.newSessionDeleteLogic = !!this.appConfig.getSessionDeleteFlagConfig();
        this.initTokenMonitor();
        for (let sessionIdentifier of this.sessionIdentifiers) {
            let sessionVals = this.getSessionTokensFromClientStorage(sessionIdentifier);
            if (!!sessionVals.every(val => !!val)) {
                this._sessionType = sessionIdentifier.sessionType;
                this.sessionTypeEmitter.emit(this._sessionType);
                // TODO: to be removed for 2020.06 sprint
                this.sessionService.setSessionType(this._sessionType);
            }
        }
        this.activeSessionSubject = new BehaviorSubject(this._sessionType);
    }
    getSessionType() {
        return this._sessionType;
    }
    /**
     * Fires whenever a valid routing event triggers it.
     *
     * Checks for the presence of an active session and, upon
     * locating one, will emit out the session type through the activeSessionSubject
     */
    checkForSession() {
        if (!!this._sessionType) {
            this.activeSessionSubject.next(this._sessionType);
            return of(true);
        }
        for (let sessionIdentifier of this.sessionIdentifiers) {
            let sessionVals = this.getSessionTokensFromClientStorage(sessionIdentifier);
            console.log(sessionVals.every(val => !!val));
            if (sessionVals.every(val => !!val)) {
                return this.httpService
                    .post(this.appConfig.getSessionServiceConfig().sessionKeepAliveUrl)
                    .pipe(map(res => {
                    this._sessionType = sessionIdentifier.sessionType;
                    // TODO: to be removed for 2020.06 sprint
                    this.sessionService.setSessionType(this._sessionType);
                    this.activeSessionSubject.next(this._sessionType);
                    console.log('killing router subscription');
                    console.log('Active Session Identified As ====>', this._sessionType);
                    return true;
                }), catchError$1(err => {
                    this._sessionType = null;
                    // TODO: to be removed for 2020.06 sprint
                    this.sessionService.setSessionType(this._sessionType);
                    this.activeSessionSubject.next(this._sessionType);
                    this.deleteSessionTokensOnAppLoad();
                    console.log('Session is not active');
                    if (!!this.postLogin) {
                        this.postLogin = false;
                        this.router.navigateByUrl('/sign-off?error');
                    }
                    return throwError(err);
                }));
            }
        }
        this._sessionType = null;
        // TODO: to be removed for 2020.06 sprint
        this.sessionService.setSessionType(this._sessionType);
        this.activeSessionSubject.next(this._sessionType);
        return of(false);
    }
    /**
     * Retrieve the sessionObservable; allows utilities like guards to indicate that
     * authservice should handle failed keepalive calls by redirecting to sign-off module
     * @param postLogin - indicates whether the request for sessionObservable was triggered by a auth-dependent route-guard
     */
    getSessionObservable(postLogin) {
        this.postLogin = !!postLogin ? true : this.postLogin;
        return this.activeSessionSubject.asObservable();
    }
    /**
    *This method gets partnerkey for identifing the partner.
    */
    setSiteId(partnerKey) {
        if (partnerKey) {
            this.getPartnerId.next(partnerKey);
        }
    }
    deleteSessionTokensOnAppLoad() {
        let headersVar = !this.newSessionDeleteLogic ? this.appConfig.getHttpServiceConfig().headersToSendFromPreviousResponse
            : this.appConfig.getHttpServiceConfig().headersToSendFromPreviousResponsenewlogic;
        // let headersVar = this.appConfig.getHttpServiceConfig().headersToSendFromPreviousResponse;  // CAP-Changes Story# GBC-7605
        if (headersVar) {
            //let sessionAliveCookie = this.cookieService.getCookie('keepSessionAlive');
            //sessionAliveCookie ? '' : this.httpService.deleteSessionTokens();   // Story# GBC-6777
            for (let headerInfo of headersVar) {
                if (headerInfo.deleteOnAppLoad) {
                    // let value = this.storageService.get(
                    //   headerInfo.headerNameInPreviousResponse
                    // );
                    // if (value) {
                    this.cookieService.deleteCookie(headerInfo.headerNameInPreviousResponse, '/');
                    this.cookieService.deleteCookie(headerInfo.headerNameInPreviousResponse, '/', '.online.citi.com');
                    this.cookieService.deleteCookie(headerInfo.headerNameInPreviousResponse, '/', '.citi.com');
                }
            }
        }
    }
    /**
     * Resets the router subscription for establishing valid session.
     */
    resetAuthServiceSubscription() {
        // this.navigationEventSubscription = this.router.events
        //   .pipe(filter((event: RouterEvent) => event instanceof NavigationEnd))
        //   .subscribe(event => {
        //     this.checkForSession();
        //   });
        this.checkForSession();
    }
    initTokenMonitor() {
        if (this._isSSRApp)
            return;
        this.tokenMonitorSubscription = this.router.events
            .pipe(filter(event => {
            return event instanceof GuardsCheckEnd;
        }))
            .subscribe((event) => {
            console.log('The initial route is: ', this.router.url);
            console.log('session type is ', this._sessionType);
            console.log(event);
            if (this.isTokenWhiteListed(event))
                return;
            else {
                console.log(this.constructor.name, new Date(), '\n', 'pre-login and moving across top-level routes, clearing tokens');
                this.httpService.clearSessionTokens();
                this.deleteSessionTokensOnAppLoad();
            }
        });
    }
    isTokenWhiteListed(event) {
        let initialRoute = this.router.url.split('/')[1];
        let targetRoute = event.url.split('/')[1];
        console.log(initialRoute, targetRoute);
        if (!!this._sessionType) {
            console.log(this.constructor.name, new Date(), '\n', 'session is valid, no need to clear tokens');
            return true;
        }
        else if (targetRoute.indexOf('paypal') > -1 ||
            initialRoute.indexOf('sandbox.paypal') > -1) {
            console.log(this.constructor.name, new Date(), '\n', 'route is paypal, so do not clear tokens at this point');
            return true;
        }
        else if (event.url.indexOf('forced-reset-password') > -1) {
            console.log(this.constructor.name, new Date(), '\n', 'route is forced-reset-password, so do not clear tokens at this point');
            return true;
        }
        else if (event.url.indexOf('update-userId') > -1) {
            console.log(this.constructor.name, new Date(), '\n', 'route is update-userId, so do not clear tokens at this point');
            return true;
        }
        else if (initialRoute == targetRoute) {
            console.log(this.constructor.name, new Date(), '\n', 'top level route matches ');
            return true;
        }
        else if (this.router.url.indexOf('/bank/registration') > -1 ||
            event.url.indexOf('/bank/registration') > -1) {
            // DRR 12200
            console.log(this.constructor.name, new Date(), '\n', 'route is /bank/registration, do not clear tokens');
            return true;
        }
        else if (this.router.url.indexOf('/citi-flex-loan') > -1 ||
            event.url.indexOf('/citi-flex-loan') > -1) {
            // GBC 4427 DRR 12245
            console.log(this.constructor.name, new Date(), '\n', 'route is flex loan, do not clear tokens');
            return true;
        }
        else if (this.router.url.indexOf('/tandc') > -1 ||
            event.url.indexOf('/tandc') > -1) {
            // GBC-5050
            console.log(this.constructor.name, new Date(), '\n', 'route is /tandc, do not clear tokens');
            return true;
        }
        else if (this.router.url.indexOf('/welcome') > -1 ||
            event.url.indexOf('/welcome') > -1) {
            // GBC-5050
            console.log(this.constructor.name, new Date(), '\n', 'route is /welcome, do not clear tokens');
            return true;
        }
        // add condition to end here....
        // if all conditions not true, return false;
        return false;
    }
    /**
     * Use an instance of ISessionIdentifier to try and retrieve session tokens from client storage.
     * Returns an array of booleans, indicating whether the token values were present
     * @param sessionIdentifier
     */
    getSessionTokensFromClientStorage(sessionIdentifier) {
        let sessionVals = [];
        for (let cookieConfig of sessionIdentifier.cookieNames) {
            let { cookieName, valueSeparator } = cookieConfig;
            if (isPlatformServer(this._platformId)) {
                sessionVals.push(this.cookieService.getCookie(cookieName));
            }
            else {
                sessionVals.push(this.storageService.get(cookieName));
            }
        }
        console.log(sessionVals.every(val => !!val));
        return sessionVals.map(val => !!val);
    }
    getBlacklistedUrlConfig() {
        if (sessionStorage.getItem('cbol_limitedaccess')) {
            return of(JSON.parse(sessionStorage.getItem('cbol_limitedaccess')) || []);
        }
        return this.httpService.get('/config', { headers: { channelId: 'CBOL' } }).pipe(map((res) => {
            sessionStorage.setItem('cbol_limitedaccess', JSON.stringify(res['US_GCB_CBOL']['cbol_limitedaccess']?.['routes']));
            return res['US_GCB_CBOL']['cbol_limitedaccess']?.['routes'];
        }));
    }
    isRetailLimitedAccess() {
        const sessionBranding = JSON.parse(sessionStorage.getItem('sessionPostBrandingStorage') || null);
        if (sessionBranding?.['featureFlags']?.['ff_retailLimitedAccessLogin'] === 'Y') {
            return true;
        }
        return false;
    }
    /**
     * @name - shouldSuppressAccess
     * @desc - if a user is restricted - say, has an Inactive Debit Card - then the
      suppressed routes should be made inaccessible when tried via manual address bar
      input or bookmarks
      * @returns - a boolean - whether the route has to be deactivated or allowed
    **/
    shouldSuppressLoad(route) {
        if (!this.isRetailLimitedAccess()) {
            // * User isn't limited for access
            return of(false);
        }
        return this.getBlacklistedUrlConfig().pipe(map((res) => {
            const blacklistedUrlList = res;
            const brandingJsonArray = JSON.parse(sessionStorage.getItem('updatedTopNav') || '[]');
            brandingJsonArray.forEach((navObj) => {
                navObj.navigationItems?.forEach((item) => {
                    item.items?.forEach((subItem) => {
                        if (subItem.show === false && subItem.routerLink) {
                            blacklistedUrlList.push(subItem.routerLink);
                        }
                    });
                });
            });
            console.log('Blacklisted URL List', blacklistedUrlList);
            const currRoute = route;
            let isBlacklistedRouteMatched = false;
            blacklistedUrlList.forEach((url) => {
                if (currRoute.includes(url)) {
                    isBlacklistedRouteMatched = true;
                    return;
                }
            });
            return isBlacklistedRouteMatched;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AuthorizationService, deps: [{ token: i1$1.StorageService }, { token: i1$1.AppConfigService }, { token: i1$2.Router }, { token: i2.HttpService }, { token: i1$1.SessionService }, { token: i1$1.CookieService }, { token: PLATFORM_ID }, { token: IS_SSRENDERED_APP, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AuthorizationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: AuthorizationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$1.StorageService }, { type: i1$1.AppConfigService }, { type: i1$2.Router }, { type: i2.HttpService }, { type: i1$1.SessionService }, { type: i1$1.CookieService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [IS_SSRENDERED_APP]
                }] }] });

class DeepdropService {
    constructor(authService, appConfigService, _window, _contentService) {
        this.authService = authService;
        this.appConfigService = appConfigService;
        this._window = _window;
        this._contentService = _contentService;
    }
    canActivate(route, state) {
        return this.authService.checkForSession().pipe(switchMap(res => {
            if (!!res) {
                return this.authService.shouldSuppressLoad(state.url).pipe(map$1((data) => {
                    if (!data)
                        return true;
                    // * redirect to dashboard if customer tries to access blacklisted route
                    this._window.location.href = '/US/ag/parent-interstitial';
                    return false;
                }));
            }
            else {
                this.redirectToLogin(state);
                return of(false);
            }
        }), catchError$1(err => {
            console.error("Route Error >> ", err);
            this.redirectToLogin(state);
            return of(false);
        }));
    }
    redirectToLogin(state) {
        window.sessionStorage.setItem('isDeepdrop', 'true');
        let nextScreen = state.url.substr(1, state.url.length);
        /*
          Below condition is added to support LoginAuth with special login page, while preserving exisiting
          deepdrop logic. LoginAuth team --> loginscreenId.
          If loginscreenId does not exist in url, then treat nextScreen as default.
        */
        if (state.url.includes('loginscreenId')) {
            nextScreen = state.url
                .substr(1, state.url.length)
                .split('?')
                .join('&');
        }
        console.log('nextScreen -------------------------------------------------------->  ', nextScreen);
        /*            let params = state.url.split('?')[1];
    
                  if(route.url.toString() != undefined) {
                     nextScreen += '_' + route.url;
                  }
                  if(params != undefined) {
                    nextScreen += "&" + params;
                  }
      */
        if (this.isSSRDeepdropFallback()) {
            let destUrl = this._window.location.protocol + '//' + this._window.location.host;
            this._window.location.href =
                destUrl +
                    '/US/JSO/loginpage/retarget.action?next_ag_screen=' +
                    nextScreen +
                    '&deepdrop=true';
        }
        else {
            nextScreen = nextScreen.replace(/\?/g, '&');
            let destUrl = this.appConfigService.getnewCitiHostName() +
                "/login?nextRoute=";
            this._window.location.href =
                destUrl +
                    nextScreen;
        }
    }
    isSSRDeepdropFallback() {
        this._contentService.getStaticBundle('USCBOL').subscribe((res) => {
            let isSSRDeepdropFallback = this._contentService.get('USCBOL', 'config', 'FallbackParameters', 'isSSRDeepdropFallback');
            if (isSSRDeepdropFallback) {
                return true;
            }
            else {
                return false;
            }
        }, error => {
            return false;
        });
        return false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepdropService, deps: [{ token: AuthorizationService }, { token: i1$1.AppConfigService }, { token: WINDOW }, { token: i2.ContentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepdropService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepdropService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: AuthorizationService }, { type: i1$1.AppConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: i2.ContentService }] });

class VisitorActivate {
    constructor(router) {
        this.router = router;
    }
    canActivate() {
        return true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: VisitorActivate, deps: [{ token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: VisitorActivate }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: VisitorActivate, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Router }] });

/**
 * module CoreServicesModule
 */
/**
 * The FriendOnlyActivate Service
 * class FriendOnlyActivate
 *
 * This Service tries to find if the user is a friend or not . App config is being used. It would redirect to /unauthorized if the user is not a friend and
 * this guard is used in route. This guard should be used only if a guard needs to be activated for Friend customer and should be deactivated even for a Customer role
 */
class FriendOnlyActivate {
    constructor(router, _sessionService) {
        this.router = router;
        this._sessionService = _sessionService;
    }
    canActivate() {
        if (this._sessionService.isFriend()) {
            return true;
        }
        else {
            this.router.navigateByUrl('/unauthorized');
            return false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FriendOnlyActivate, deps: [{ token: i1$2.Router }, { token: i1$1.SessionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FriendOnlyActivate }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FriendOnlyActivate, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: i1$1.SessionService }] });

/**
 * module CoreServicesModule
 */
/**
 * The FriendActivate Service
 * class FriendActivate
 *
 * This Service tries to find if the user is either a friend or customer . App config is being used. It would redirect to /unauthorized if the user is not a customer and
 * this guard is used in route. This guard should be used only if a guard needs to be activated for either customer or Friend. Hierarchy is Customer, Friend and Visitor. Since customer role is the highest .if this guard is provided in the route , it would be activated even if he is a customer.
 */
class FriendActivate {
    constructor(router, _sessionService) {
        this.router = router;
        this._sessionService = _sessionService;
    }
    canActivate() {
        if (this._sessionService.isCustomer() || this._sessionService.isFriend()) {
            return true;
        }
        else {
            this.router.navigateByUrl('/unauthorized');
            return false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FriendActivate, deps: [{ token: i1$2.Router }, { token: i1$1.SessionService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FriendActivate }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: FriendActivate, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: i1$1.SessionService }] });

class TMXService {
    constructor(_appConfigService, _platformId, _window, _document) {
        this._appConfigService = _appConfigService;
        this._platformId = _platformId;
        this._window = _window;
        this._document = _document;
        if ((isPlatformBrowser(this._platformId))) {
            let tmxjs = './assets/js/fp-clientlib-v5.js';
            this.script = this._document.createElement('script');
            this.script.setAttribute('src', tmxjs);
            this.script.setAttribute('id', 'fp-clientlib-v5');
            if (this._appConfigService.getBusinessId() === 'USMKT') {
                this.script.defer = true;
            }
            if (!this._document.getElementById('fp-clientlib-v5')) {
                this._document.getElementsByTagName('head')[0].appendChild(this.script);
            }
        }
    }
    getRequestParams() {
        this.tmxobfParams();
    }
    tmxobfParams() {
        const date = new Date(), strToHash = date.toString() +
            this.getuuid() +
            this._appConfigService.getHttpServiceConfig().defaultHeaders.channelId, hash = rs.crypto.Util.sha256(strToHash).toString(), tmx_url = this._appConfigService.getConfig('tmx_url') + hash;
        if (isPlatformBrowser(this._platformId)) {
            Cookie.set('tmx_sessionid', hash, undefined, '/', '.citi.com', true);
        }
        console.log('tmx obf mp', hash);
        var url = new URL(tmx_url);
        var org_id = url.searchParams.get("org_id");
        threatmetrix.profile("content22.online.citi.com", org_id, hash);
        this.noscript = this._document.createElement('noscript');
        this.noscript.setAttribute('src', ('<iframe style="width: 100px; height: 100px; border: 0; position: absolute; top: -5000px;" src="http://content22.online.citi.com/fp/tags?org_'));
    }
    generateTMXSessionId() {
        const date = new Date(), strToHash = date.toString() +
            this.getuuid() +
            this._appConfigService.getHttpServiceConfig().defaultHeaders.channelId, hash = rs.crypto.Util.sha256(strToHash).toString(), tmx_url = this._appConfigService.getConfig('tmx_url') + hash;
        if (isPlatformBrowser(this._platformId)) {
            Cookie.set('tmx_sessionid', hash, undefined, '/', '.citi.com', true);
        }
        if (this._window) {
            this._window.tmx_sessionid = hash;
        }
        return tmx_url;
    }
    getuuid() {
        const uuid = rs.crypto.Util.getRandomHexOfNbytes(16);
        return uuid;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TMXService, deps: [{ token: i1$1.AppConfigService }, { token: PLATFORM_ID }, { token: WINDOW }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TMXService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: TMXService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$1.AppConfigService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

class DeepdropErrorActivate {
    constructor(router) {
        this.router = router;
    }
    canActivate() {
        if (window.sessionStorage.getItem('isDeepdrop') == null ||
            window.sessionStorage.getItem('isDeepdrop') == 'false') {
            return true;
        }
        else {
            let sessionPostBrandingStorage = window.sessionStorage.getItem('sessionPostBrandingStorage');
            if (!sessionPostBrandingStorage) {
                return true;
            }
            else {
                let customerType;
                if (sessionPostBrandingStorage.includes('customerType')) {
                    let firstIndex = sessionPostBrandingStorage.indexOf('customerType');
                    const lastIndex = sessionPostBrandingStorage.indexOf(',', firstIndex);
                    customerType = sessionPostBrandingStorage.substring(firstIndex, lastIndex);
                }
                if (customerType == null)
                    return true;
                else {
                    if (customerType.includes('SPF')) {
                        this.router.navigateByUrl('/US/ag/accountdetails');
                    }
                    else if (customerType.includes('BANK') ||
                        customerType.includes('MRC')) {
                        this.router.navigateByUrl('/US/ag/mrc/dashboard');
                    }
                    return false;
                }
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepdropErrorActivate, deps: [{ token: i1$2.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepdropErrorActivate }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: DeepdropErrorActivate, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Router }] });

/**
 * module CoreServicesModule
 */
/**
 * The CustomerActivate Service
 * class CustomerActivate
 *
 * This Service tries to find if the user is a customer or not . App config is being used. It would redirect to /unauthorized if the user is not a customer and
 * this guard is used in route
 */
class CustomerActivate {
    constructor(router, _authService) {
        this.router = router;
        this._authService = _authService;
    }
    canActivate() {
        return this._authService.checkForSession().pipe(map(res => {
            if (!!res) {
                return true;
            }
            else {
                this.router.navigateByUrl('/unauthorized');
                return false;
            }
        }), catchError$1(err => {
            this.router.navigateByUrl('/unauthorized');
            return of(false);
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CustomerActivate, deps: [{ token: i1$2.Router }, { token: AuthorizationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CustomerActivate }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CustomerActivate, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: AuthorizationService }] });

class CitiSecurityModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiSecurityModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.14", ngImport: i0, type: CitiSecurityModule, imports: [AmwModule], exports: [AmwModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiSecurityModule, providers: [
            E2eService,
            E2eServiceFallback,
            DeepdropService,
            VisitorActivate,
            FriendOnlyActivate,
            FriendActivate,
            TMXService,
            DeepdropErrorActivate,
            CustomerActivate,
            WINDOW_PROVIDER
        ], imports: [AmwModule, AmwModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: CitiSecurityModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [AmwModule],
                    exports: [AmwModule],
                    providers: [
                        E2eService,
                        E2eServiceFallback,
                        DeepdropService,
                        VisitorActivate,
                        FriendOnlyActivate,
                        FriendActivate,
                        TMXService,
                        DeepdropErrorActivate,
                        CustomerActivate,
                        WINDOW_PROVIDER
                    ]
                }]
        }] });

/**
 * module CoreServicesModule
 * internal
 */

/**
 * Route guard to control logic that decides which Angular application should be used.
 *
 * First checks for a feature flag pertaining to the base route.
 *  If the feature flag exists and is set to true, the 'ag' app is used.
 *  If the feature flag exists and is set to false, the 'nga' app is used.
 *  If the feature flag does not exist then the routing config is used.
 * The feature flags will not be defined when the user is not logged in as it is a post-login ONLY feature.
 *
 * For the routing config, this may already be cached in the browser to speed up this process.
 * If the cache exists and it has not expired (based the number of milliseconds elapsed), that is used.
 * If the cache does not exist OR if it has expired, make an http request for the config from static content
 * (this is an async call that needs to synchronized which is why everything is in async functions and promises with awaits).
 *
 * The routing config is a map of all onboarded routes with a list of 'allowed applications' that can be used.
 * If the current application is NOT in the allowed list for that route, the URL is reformed with the first item in the allowed list.
 * If the route entry does not exist at all, the 'ag' app is used as a default.
 *    This is used only as a last resort when no onboarding has been done at all.
 */
class ModFedRouteGuard {
    constructor(router, document, _httpService, appConfigService) {
        this.router = router;
        this.document = document;
        this._httpService = _httpService;
        this.appConfigService = appConfigService;
        this.CACHE_MAX_AGE = 3600000; // 1 hour in milliseconds.
        this.FEATURE_SET_NAME = 'ModFedRoutes';
        this.STORAGE_KEY = 'modFedRoutes';
        this.modFedRedirect = new BehaviorSubject(null);
        this.window = this.document.defaultView;
    }
    canActivate(route, state) {
        this.log('route: ' + route);
        this.log('state: ' + state);
        this.log('destinationRoute: ' + this.getDestinationRoute(state));
        // Let assets pass through. This is only here for the wildcard route. This might be removable in the future.
        if (state.url.startsWith('/assets/') ||
            state.url.startsWith('/root/assets/') ||
            state.url.startsWith('/root/cbol-core-assets/') ||
            state.url.startsWith('/citi-branding-assets/') ||
            state.url.startsWith('/cds-assets/') ||
            state.url.startsWith('/root/cds-assets/') ||
            state.url.startsWith('/cbol-core-assets/') ||
            state.url.startsWith('/root/citi-branding-assets/') ||
            state.url.startsWith('/commonui-assets/') ||
            state.url.startsWith('/root/commonui-assets/') ||
            this.shouldPassThrough(route)) {
            return this.destinationGood(state.url);
        }
        return this.useRouteConfig(route, state);
    }
    destinationGood(url) {
        this.log(url);
        return true;
    }
    useRouteConfig(activatedRoute, state) {
        return new Promise(async (resolve, reject) => {
            // Skips all futher logic if the proper query param exists.
            if (this.shouldPassThrough(activatedRoute))
                resolve(true);
            const destinationRouteObject = {
                origin: this.getOrigin(),
                countryCode: this.getCountryCode(),
                destinationRoute: this.getDestinationRoute(state),
            };
            this.log('destination route: ' + destinationRouteObject.destinationRoute);
            const destinationBaseRoute = this.getDestinationBaseRoute(destinationRouteObject.destinationRoute);
            this.log('destination base route: ' + destinationBaseRoute);
            const currentApp = this.getCurrentApp();
            this.log('current app: ' + currentApp);
            const featureFlagStatus = this.getFeatureFlagStatusByRouteString(destinationBaseRoute);
            this.log('Feature flag status: ' + featureFlagStatus);
            if (featureFlagStatus) {
                this.log('feature flag is true');
                currentApp === 'nga' ? resolve(true) : resolve(this.sendToDestinationApp({ ...destinationRouteObject, destinationApp: 'nga' }));
            }
            else if (featureFlagStatus == false) {
                this.log('feature flag is false');
                currentApp === 'ag' ? resolve(true) : resolve(this.sendToDestinationApp({ ...destinationRouteObject, destinationApp: 'ag' }));
            }
            else {
                this.log('feature flag does not exist');
                // For if the desired feature flag does not exist OR NO feature flags exist i.e. pre-login
                const availableApplications = await Promise.resolve(this.getAllowableApps(destinationBaseRoute));
                this.log('available applications: ' + availableApplications);
                const modFedThrottlingRoutes = this.appConfigService.getModFedThrottlingRoutes();
                const throttlingRoutesKeys = Object.keys(modFedThrottlingRoutes);
                if (!this.isLoggedIn() && currentApp === 'ag' && throttlingRoutesKeys.length > 0 && throttlingRoutesKeys.includes(destinationBaseRoute)) {
                    // This route is included in the mod fed throttling routes in app config.
                    if (modFedThrottlingRoutes[destinationBaseRoute][1]) {
                        // Throttling is enabled for this route (second value is true).
                        const throttlePercentage = modFedThrottlingRoutes[destinationBaseRoute][0] / 100;
                        const randomNumber = Math.random();
                        // If the random number is below the percentage, send to /US/nga, else stay on /US/ag.
                        const destinationApp = randomNumber < throttlePercentage ? availableApplications[1] : availableApplications[0];
                        if (currentApp === destinationApp) {
                            resolve(true);
                        }
                        else {
                            resolve(this.sendToDestinationApp({ ...destinationRouteObject, destinationApp: destinationApp }));
                        }
                    }
                }
                if (availableApplications && availableApplications.includes(currentApp)) {
                    // The current application is within the list of acceptable applications for that route.
                    resolve(true);
                }
                else if (availableApplications && availableApplications.length > 0) {
                    // The current application is NOT included in the list of acceptable applications, go to the first one in the list as default.
                    resolve(this.sendToDestinationApp({ ...destinationRouteObject, destinationApp: availableApplications[0] }));
                }
                else {
                    // Either the route does not exist in the routes or there was another issue. Either way, go to the ag app.
                    // This can eventually be swapped around to go to the nga app once a critical mass has been hit in number of onboarded routes.
                    currentApp === 'ag' ? resolve(true) : this.sendToDestinationApp({ ...destinationRouteObject, destinationApp: 'ag' });
                }
            }
        });
    }
    /**
     * Checks for a specific query param that allows the logic in the route guard to be bypassed, allowing the user through to the destination regardless of other conditions.
     *
     * @param activatedRoute ActivatedRouteSnapshot
     * @returns if the router logic can be skipped.
     */
    shouldPassThrough(activatedRoute) {
        return activatedRoute.queryParams['forceRoute'] === 'true';
    }
    /**
     * Redirects the window to a route with the following pattern origin/countryCode/destinationApp/destinationRoute
     *
     * @param {RoutingObject} routingObject - Object containing information for the destination route.
     * @returns Returns false as the route guard should be redirecting instead of continuing to the initial route.
     */
    sendToDestinationApp(routingObject) {
        const destinationUrl = `${routingObject.origin}/${routingObject.countryCode}/${routingObject.destinationApp}${routingObject.destinationRoute}`;
        this.log('final destination URL: ' + destinationUrl);
        this.modFedRedirect.next(destinationUrl);
        return false;
    }
    /**
     * Gets all of the allowed applications for each route.
     *
     * @returns All of the available routes and their allowed applications.
     */
    getRouteConfig() {
        return new Promise((resolve, reject) => {
            try {
                const cachedRoutes = this.getCachedRoutes();
                if (cachedRoutes && this.checkCacheTimestamp(cachedRoutes) && cachedRoutes.routes) {
                    this.log('cache is good!');
                    resolve(cachedRoutes.routes);
                    return;
                }
                const configUrl = window.location.origin + this.appConfigService.getConfig('customConfig').brandingEndpoint + '/modFedRouting.json';
                this.log('config fetch URL: ' + configUrl);
                this._httpService.get(configUrl).pipe(take(1)).subscribe({
                    next: (response) => {
                        this.log('config response: ' + JSON.stringify(response));
                        this.cacheRoutes(response);
                        resolve(response);
                    }, error: (error) => {
                        this.log('config fetch error: ' + JSON.stringify(error));
                        resolve(undefined);
                    }
                });
            }
            catch (e) {
                resolve(undefined);
            }
        });
    }
    /**
     * Attempts to get the content file from the content service instead of the webserver.
     */
    // getRouteConfigV2() {
    //   const CONTENT_URL = this.appConfigService.getConfig('contentService').staticBaseUrl + "/staticcms/USGCB/en_US/appid/cbol_ag_container.json";
    //   this.log('new content URL: ' + CONTENT_URL)
    //   this._httpService.get(CONTENT_URL).pipe(take(1)).subscribe({
    //     next: (response) => {
    //       console.log(response);
    //       if (response) {
    //         this.log('new content: ' + response.content.cbol_ag_container)
    //         this.log('new mod fed content: ' + response.content.cbol_ag_container.copy$$mod_fed_route_config);
    //       }
    //     }, error: (error) => {
    //       this.log('config fetch error: ' + JSON.stringify(error));
    //     }
    //   })
    // }
    /**
     * Attempts to get the routes object from the cache if possible.
     * Will return undefined if the object does not exist or if an error occurs.
     *
     * @returns cached routes object.
     */
    getCachedRoutes() {
        try {
            const cachedRoutesString = localStorage.getItem(this.STORAGE_KEY);
            this.log('cached routes: ' + cachedRoutesString);
            return JSON.parse(cachedRoutesString);
        }
        catch (error) {
            this.log('error getting the routes from the cache. ' + JSON.stringify(error));
            return undefined;
        }
    }
    /**
     * Caches the routes object to be obtained later.
     * Adds a timestamp based on the time that the caching happens.
     *
     * @param routes The routes to be stored.
     */
    cacheRoutes(routes) {
        try {
            this.log('caching the routes.');
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify({ routes, timestamp: Date.now() }));
        }
        catch (e) {
            this.log('error caching routes: ' + JSON.stringify(e));
        }
    }
    /**
     * Checks the cached routes to see if they are good to use or not.
     * Will not use it if a certain amount of time has passed.
     *
     * @param cache cache to be verified.
     * @returns If the cache is good to use or not.
     */
    checkCacheTimestamp(cache) {
        // I have a feeling this might not work.
        const timestampDifference = cache.timestamp - Date.now();
        this.log('timestampDifference for cache: ' + timestampDifference);
        return Math.abs(timestampDifference) < this.CACHE_MAX_AGE;
    }
    /**
     * Gets the list of allowable applications for the desired route.
     * e.g. if route 'test-route' only allows the 'ag' application, ['ag'] will be returned.
     *
     * This may return a longer list if there is desire to let test and target or Akamai do the decision and redirecting.
     *
     * @param route The destination route.
     * @returns The list of strings containing the allowable apps for that route.
     */
    getAllowableApps(route) {
        return new Promise(async (resolve, reject) => {
            const routeConfig = await this.getRouteConfig();
            resolve(routeConfig ? routeConfig[route] : undefined);
        });
    }
    /**
     * Gets the country code for the current URL.
     * http://uat1.online.citi.com/US/nga/parent/child?query=param -> US
     *
     * @returns The country code of the current path.
     */
    getCountryCode() {
        return this.window.location.pathname.split('/')[1];
    }
    /**
     * Returns the route that is trying to be reached.
     */
    getDestinationRoute(state) {
        return state.url;
    }
    /**
     * returns the string of the current Angular application.
     * As of the time of this writing, for the mod fed applications it should be 'nga'.
     * The standard CSR app should be ag.
     * The mod fed app might change in the future and there may be additional ones at some point.
     *
     * @returns The string representation of the current application.
     */
    getCurrentApp() {
        return this.window.location.pathname.split('/')[2];
    }
    /**
     * Returns just the origin of the URL. Everythign before the /US portion.
     * e.g. http://online.citi.com/US/nga/test -> http://online.citi.com
     */
    getOrigin() {
        return this.window.location.origin;
    }
    /**
     * Takes in the string of the URL past the application and returns the first section.
     * Removes any query params first. Also removes any fragments (#) and whatever is going on with parenthesis...which apparently are allowed in a URL?
     * If the route is empty, return an empty string.
     *
     * @param {string} route representation of the desired path after the application.
     * @returns
     */
    getDestinationBaseRoute(route) {
        if (route.length == 0)
            return '';
        return route.split('?')[0].split('#')[0].split('(')[0].split('/')[1];
    }
    /**
     * Takes in a basepath route and searches for if that route exists in the mod fed featureflags.
     * If the flag exists, the 'isVisible' value is returned.
     * If the route does not exist, undefined is returned.
     * Only the base path should be passed in NOT the full path or child paths.
     * e.g.
     *  The route '/US/nga/mrc/dashboard' should pass in 'mrc' NOT 'mrc/dashboard' OR 'dashboard' as that is a different route entirely.
     *
     * The resulting feature flag name is ff_ + modfed + the passed in route without underscores, dashes, or spaces and then all lowercase.
     * e.g. route /US/nga/example-Route_test -> ff_modfedexampleroutetest
     *
     *
     * @param {string} baseRoute base path of the route.
     * @returns boolean representing the status of the feature flag.
     */
    getFeatureFlagStatusByRouteString(baseRoute) {
        // If they are not logged in, just end the function. No use in continuing.
        if (!this.isLoggedIn())
            return undefined;
        // Using a regex to remove underscores, dashes, and spaces since replaceAll doesn't have as wide of compatibility.
        const sanitizedRoute = baseRoute.replace(/[_\- ]/g, "").toLowerCase();
        const featureFlagToFind = `ff_modfed${sanitizedRoute}`;
        this.log('Searching feature flags for ' + featureFlagToFind);
        const featureSet = this.getModFedFeatureSet();
        if (featureSet && featureSet.features) {
            // For if the mod fed feature set exists
            this.log('entitlementFeatureFlags exists. Checking that.');
            try {
                return featureSet.features.find((feature) => feature.id === featureFlagToFind).isVisible;
            }
            catch (e) {
                return undefined;
            }
        }
        else {
            // Use fallback method for if the feature set does NOT exist
            this.log('Using feature flag fallback.');
            return this.getFeatureFlagFallbackStatus(featureFlagToFind);
        }
    }
    /**
     * Checks if the user is logged in by checking if session post branding storage exists.
     * If the object does not exist, the user is probably not logged in.
     *
     * @returns logged in status based on the presence of session post branding storage.
     */
    isLoggedIn() {
        return !!sessionStorage.getItem('sessionPostBrandingStorage');
    }
    /**
     * Gets the feature set for mod fed.
     * This only exists if logged in. If not logged in, this will return false.
     *
     * @returns The featureSet for JUST the mod fed feature flags
     */
    getModFedFeatureSet() {
        try {
            const entitlementFeatureSets = JSON.parse(sessionStorage.getItem('sessionPostBrandingStorage'))['entitlementFeatureFlags'];
            return entitlementFeatureSets.featureSet.find((set) => set.id === this.FEATURE_SET_NAME);
        }
        catch (e) {
            this.log('error getting entitlement flags');
            return undefined;
        }
    }
    /**
     * Checks the 'featureflags' field in session storage for if the feature flag exists there.
     * Since this stores a string, this is converted into a boolean.
     *
     * @param featureFlagName Flag to find.
     * @returns boolean representation of the flag status.
     */
    getFeatureFlagFallbackStatus(featureFlagName) {
        const featureFlagObject = this.getFeatureFlagFallbackObject();
        if (!featureFlagObject)
            return undefined;
        const flagStatus = featureFlagObject[featureFlagName];
        switch (flagStatus) {
            case 'Y':
            case 'y':
                return true;
            case 'N':
            case 'n':
                return false;
            default:
                return undefined;
        }
    }
    /**
     * Get the flattened version of feature flags. This is less reliable as there may be name clashes.
     * This is only a fallback to cover up other issues with BCS and feature flags so it may be removed sometime in the future.
     *
     * @returns object of all feature flags.
     */
    getFeatureFlagFallbackObject() {
        try {
            return JSON.parse(sessionStorage.getItem('sessionPostBrandingStorage'))['featureFlags'];
        }
        catch (e) {
            this.log('error getting flattened flags');
            return undefined;
        }
    }
    /**
     * Just used for logging things.
     * To turn off all logs, simple comment out the contents of this function.
     *
     * @param log string to pass to the logger.
     */
    log(log) {
        console.log(`***** MODULE FEDERATION: ${log} *****`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ModFedRouteGuard, deps: [{ token: i1$2.Router }, { token: DOCUMENT }, { token: i2.HttpService }, { token: i1$1.AppConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ModFedRouteGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.14", ngImport: i0, type: ModFedRouteGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i2.HttpService }, { type: i1$1.AppConfigService }] });

/*
 * Public API Surface of citi-security
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmwComponent, AmwModule, AuthorizationService, CitiSecurityModule, CustomerActivate, DeepdropErrorActivate, DeepdropService, E2eService, E2eServiceFallback, FriendActivate, FriendOnlyActivate, ModFedRouteGuard, TMXService, VisitorActivate };
